import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/app/ui/assets/svg/info-square.svg'
import _imports_1 from '@/app/ui/assets/svg/close-white.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-601ef894")

_pushScopeId("data-v-601ef894")
const _hoisted_1 = { class: "w-full" }
const _hoisted_2 = {
  key: 0,
  class: "grid gap-8 grid-cols-2 w-4/6 mt-6"
}
const _hoisted_3 = {
  class: "w-full flex flex-row justify-between items-center bg-aqua-lp-200 rounded-md border-2 border-dashed py-3 px-4 mt-8",
  style: {"border-color":"#47a1bc"}
}
const _hoisted_4 = { class: "text-gray-lp-300 text-14px" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Anda bisa menggabungkan STT tujuan ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" ke KARGO tujuan ")
const _hoisted_7 = {
  key: 0,
  class: "w-full space-y-6 mt-8"
}
const _hoisted_8 = { class: "grid gap-x-5 gap-y-6 grid-cols-2 w-3/4" }
const _hoisted_9 = {
  key: 0,
  class: "col-span-2 flex flex-col gap-y-2"
}
const _hoisted_10 = { class: "rounded-2xl border border-gray-lp-1600 divide-y divide-gray-lp-1600 text-black-lp-300" }
const _hoisted_11 = { class: "grid grid-cols-4 p-3 gap-x-8" }
const _hoisted_12 = /*#__PURE__*/_createVNode("div", { class: "py-2" }, null, -1)
const _hoisted_13 = /*#__PURE__*/_createVNode("hr", { class: "my-8" }, null, -1)
const _hoisted_14 = { key: 1 }
const _hoisted_15 = { class: "grid gap-4 grid-cols-3 w-full mt-8" }
const _hoisted_16 = { class: "w-2/12 mb-2 flex items-end col-span-1" }
const _hoisted_17 = /*#__PURE__*/_createVNode("hr", { class: "mt-4" }, null, -1)
const _hoisted_18 = {
  key: 0,
  class: "grid gap-8 grid-cols-4 w-full mt-6"
}
const _hoisted_19 = {
  key: 2,
  class: "mt-6"
}
const _hoisted_20 = { key: 4 }
const _hoisted_21 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_22 = {
  class: "flex flex-row items-center self-center py-2 px-4 rounded-lg gap-x-3 max-w-max mb-8",
  style: {"background":"#5E9AF8"}
}
const _hoisted_23 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  class: "w-4",
  alt: "info-square"
}, null, -1)
const _hoisted_24 = { class: "text-white whitespace-normal text-12px" }
const _hoisted_25 = /*#__PURE__*/_createVNode("div", { class: "py-2" }, null, -1)
const _hoisted_26 = {
  class: "notification-card-weight w-6/20 z-30 flex flex-row justify-between items-center bg-yellow-lp-400 rounded-md border-2 border-dashed py-3 px-4 mt-8",
  style: {"border-color":"#F09035"}
}
const _hoisted_27 = { class: "text-gray-lp-300 text-12px" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Gamification = _resolveComponent("Gamification")!
  const _component_DatePickers = _resolveComponent("DatePickers")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_SelectSearch = _resolveComponent("SelectSearch")!
  const _component_Icons = _resolveComponent("Icons")!
  const _component_CargoFlightManualSection = _resolveComponent("CargoFlightManualSection")!
  const _component_Title = _resolveComponent("Title")!
  const _component_LpInput = _resolveComponent("LpInput")!
  const _component_Select = _resolveComponent("Select")!
  const _component_WeightSummaryStt = _resolveComponent("WeightSummaryStt")!
  const _component_WeightSummaryTimbangUlang = _resolveComponent("WeightSummaryTimbangUlang")!
  const _component_SectionUploadPhotoForWeightAdjusment = _resolveComponent("SectionUploadPhotoForWeightAdjusment")!
  const _component_LpButton = _resolveComponent("LpButton")!
  const _component_ScanFailedCard = _resolveComponent("ScanFailedCard")!
  const _component_CustomDropdown = _resolveComponent("CustomDropdown")!
  const _component_DimensionPerKoli = _resolveComponent("DimensionPerKoli")!
  const _component_Notification = _resolveComponent("Notification")!
  const _component_NotificationCommodityGrouping = _resolveComponent("NotificationCommodityGrouping")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    (_ctx.showModalTest)
      ? (_openBlock(), _createBlock(_component_Gamification, { key: 0 }))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_1, [
      (!_ctx.isRTC && !_ctx.selectedCargoTypeV2BookingManual)
        ? (_openBlock(), _createBlock("div", _hoisted_2, [
            _createVNode(_component_DataWrapper, {
              label: _ctx.$t('cargo.labels.date')
            }, {
              default: _withId(() => [
                _createVNode(_component_DatePickers, {
                  placeholder: _ctx.$t('Tanggal'),
                  modelValue: _ctx.form.estDepartureDate,
                  minDate: new Date(),
                  onSelected: _ctx.setPeriodeStart,
                  class: "my-2"
                }, null, 8, ["placeholder", "modelValue", "minDate", "onSelected"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_DataWrapper, {
              label: _ctx.$t('cargo.labels.destinationCity')
            }, {
              default: _withId(() => [
                _createVNode(_component_SelectSearch, {
                  class: "mt-1.5",
                  onFocus: _cache[1] || (_cache[1] = (e) => _ctx.fetchDestinationCity(e)),
                  onFilter: _cache[2] || (_cache[2] = (e) => _ctx.fetchDestinationCity(e)),
                  isLoading: _ctx.isLoadingCity,
                  options: _ctx.optionDestinationCity,
                  keyName: "label",
                  keyValue: "code",
                  placeholder: _ctx.$t('Pilih kota tujuan'),
                  modelValue: _ctx.destinationCity,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.destinationCity = $event)),
                  onChange: _ctx.changeDestinationCity
                }, null, 8, ["isLoading", "options", "placeholder", "modelValue", "onChange"])
              ]),
              _: 1
            }, 8, ["label"])
          ]))
        : _createCommentVNode("", true),
      (_ctx.showRecommendationRegion)
        ? (_openBlock(), _createBlock(_component_DataWrapper, {
            key: 1,
            style: {"width":"67%"}
          }, {
            default: _withId(() => [
              _createVNode("div", _hoisted_3, [
                _createVNode(_component_Icons, {
                  width: "18",
                  height: "18",
                  class: "mr-2",
                  name: "warning-circle",
                  color: "#47a1bc"
                }),
                _createVNode("p", _hoisted_4, [
                  _hoisted_5,
                  _createVNode("strong", null, _toDisplayString(_ctx.destinationCity?.name), 1),
                  _hoisted_6,
                  _createVNode("strong", null, _toDisplayString(_ctx.regionBaggingGrouping.baggingRegionDestinationId) + " - " + _toDisplayString(_ctx.regionBaggingGrouping.baggingRegionDestinationName), 1)
                ]),
                _createVNode(_component_Icons, {
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.setShowNotesDestination(false))),
                  width: "12",
                  height: "12",
                  name: "icon-x",
                  class: "cursor-pointer ml-6",
                  color: "#A7A8AA"
                })
              ])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.isCargoPlaneManual)
        ? (_openBlock(), _createBlock(_component_CargoFlightManualSection, { key: 2 }))
        : _createCommentVNode("", true),
      (_ctx.isFillForm)
        ? (_openBlock(), _createBlock(_Fragment, { key: 3 }, [
            (_ctx.isCargoPlaneManual)
              ? (_openBlock(), _createBlock("div", _hoisted_7, [
                  _createVNode(_component_Title, {
                    label: _ctx.$t('Detail Pengiriman')
                  }, null, 8, ["label"]),
                  _createVNode("div", _hoisted_8, [
                    (_ctx.isValidAwb)
                      ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                          _createVNode(_component_DataWrapper, {
                            label: _ctx.$t('cargo.labels.originCity'),
                            value: `${_ctx.form.originCityCode} - ${_ctx.form.originCityName}`
                          }, null, 8, ["label", "value"]),
                          _createVNode(_component_DataWrapper, {
                            label: _ctx.$t('cargo.labels.destinationCity'),
                            value: 
                `${_ctx.form.destinationCityCode} - ${_ctx.form.destinationCityName}`
              
                          }, null, 8, ["label", "value"]),
                          (_ctx.form.awbTracking?.length)
                            ? (_openBlock(), _createBlock("div", _hoisted_9, [
                                _createVNode(_component_Title, {
                                  label: _ctx.$t('cargo.labels.shipmentDetail'),
                                  fontSize: 14
                                }, null, 8, ["label"]),
                                _createVNode("div", _hoisted_10, [
                                  _createVNode("div", _hoisted_11, [
                                    _createVNode(_component_Title, {
                                      label: _ctx.$t('Nomor penerbangan'),
                                      fontSize: 12
                                    }, null, 8, ["label"]),
                                    _createVNode(_component_Title, {
                                      label: _ctx.$t('Tanggal keberangkatan'),
                                      fontSize: 12
                                    }, null, 8, ["label"]),
                                    _createVNode(_component_Title, {
                                      label: _ctx.$t('Estimasi keberangkatan/\u200Bkedatangan'),
                                      fontSize: 12,
                                      class: "break-words"
                                    }, null, 8, ["label"]),
                                    _createVNode(_component_Title, {
                                      label: _ctx.$t('cargo.labels.route'),
                                      fontSize: 12
                                    }, null, 8, ["label"])
                                  ]),
                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.form.awbTracking, (item) => {
                                    return (_openBlock(), _createBlock("div", {
                                      key: item.flightNumber,
                                      class: "grid grid-cols-4 p-3 gap-x-8"
                                    }, [
                                      _createVNode(_component_Title, {
                                        label: item.flightNumber,
                                        fontSize: 12,
                                        bold: "normal"
                                      }, null, 8, ["label"]),
                                      _createVNode(_component_Title, {
                                        label: item.flightDate,
                                        fontSize: 12,
                                        bold: "normal"
                                      }, null, 8, ["label"]),
                                      _createVNode(_component_Title, {
                                        label: `${item.etd} / ${item.eta}`,
                                        fontSize: 12,
                                        bold: "normal"
                                      }, null, 8, ["label"]),
                                      _createVNode(_component_Title, {
                                        label: `${item.origin} - ${item.destination}`,
                                        fontSize: 12,
                                        bold: "normal"
                                      }, null, 8, ["label"])
                                    ]))
                                  }), 128))
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          _createVNode(_component_DataWrapper, {
                            label: _ctx.$t('cargo.labels.originAirport'),
                            value: _ctx.form.airportOrigin.name
                          }, null, 8, ["label", "value"]),
                          _createVNode(_component_DataWrapper, {
                            label: _ctx.$t('cargo.labels.destinationAirport'),
                            value: _ctx.form.airportDestination.name
                          }, null, 8, ["label", "value"])
                        ], 64))
                      : _createCommentVNode("", true),
                    (!_ctx.isValidAwb)
                      ? (_openBlock(), _createBlock(_component_DataWrapper, {
                          key: 1,
                          label: _ctx.$t('cargo.labels.flightNumber'),
                          asterisk: ""
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_LpInput, {
                              onChange: _ctx.onChangeVehicleNumber,
                              modelValue: _ctx.form.vehicleNumber,
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.form.vehicleNumber = $event)),
                              placeholder: _ctx.$t('cargo.placeholders.enterFlightNumber')
                            }, null, 8, ["onChange", "modelValue", "placeholder"])
                          ]),
                          _: 1
                        }, 8, ["label"]))
                      : _createCommentVNode("", true),
                    _createVNode(_component_DataWrapper, {
                      label: _ctx.$t('cargo.labels.cargoCommodityLowercase'),
                      value: _ctx.form.cargoCommodityName
                    }, null, 8, ["label", "value"]),
                    _createVNode(_component_DataWrapper, {
                      label: _ctx.$t('cargo.labels.cargoProductLowercase'),
                      asterisk: !_ctx.isValidAwb,
                      value: _ctx.form.cargoProduct
                    }, {
                      default: _withId(() => [
                        (!_ctx.isValidAwb)
                          ? (_openBlock(), _createBlock(_component_Select, {
                              key: 0,
                              onOpenSelect: _ctx.onOpenSelectCargoProduct,
                              onCloseSelect: _ctx.onCloseSelectCargoProduct,
                              isOpenMenu: _ctx.isOpenSelectCargoProduct,
                              value: _ctx.form.cargoProduct,
                              onChooseSelect: _ctx.onSelectCargoProduct,
                              dataSelect: _ctx.listProductCargo,
                              customClass: "w-full",
                              class: "w-full whitespace-no-wrap my-2 z-10"
                            }, null, 8, ["onOpenSelect", "onCloseSelect", "isOpenMenu", "value", "onChooseSelect", "dataSelect"]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }, 8, ["label", "asterisk", "value"]),
                    (!_ctx.isValidAwb)
                      ? (_openBlock(), _createBlock(_component_DataWrapper, {
                          key: 2,
                          label: "Nature of Goods (NOG)",
                          optional: ""
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_LpInput, {
                              onChange: _ctx.onChangeNog,
                              modelValue: _ctx.form.nog,
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.form.nog = $event)),
                              placeholder: _ctx.$t('cargo.placeholders.enterNog')
                            }, null, 8, ["onChange", "modelValue", "placeholder"])
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    _createVNode(_component_DataWrapper, {
                      label: _ctx.$t('cargo.labels.totalActualCargoGrossWeight'),
                      value: `${_ctx.convertDecimal(_ctx.form.actualTotalCargoGrossWeight)} kg`
                    }, null, 8, ["label", "value"]),
                    _createVNode(_component_DataWrapper, {
                      label: _ctx.$t('cargo.labels.totalActualCargoVolumeWeight'),
                      value: `${_ctx.convertDecimal(_ctx.form.actualTotalCargoVolumeWeight)} kg`
                    }, null, 8, ["label", "value"])
                  ]),
                  _createVNode(_component_WeightSummaryStt),
                  _hoisted_12,
                  _createVNode(_component_WeightSummaryTimbangUlang, {
                    modelValue: _ctx.form,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.form = $event)),
                    isDimensionChanged: _ctx.isDimensionChanged,
                    "onUpdate:isDimensionChanged": _cache[8] || (_cache[8] = ($event: any) => (_ctx.isDimensionChanged = $event)),
                    actualChargeableWeight: _ctx.actualChargeableWeight,
                    isValidationAdjustWeightProofPhotoEnable: 
            _ctx.isValidationAdjustWeightProofPhotoEnable
          
                  }, null, 8, ["modelValue", "isDimensionChanged", "actualChargeableWeight", "isValidationAdjustWeightProofPhotoEnable"]),
                  (_ctx.isErrorWeightAdjustment)
                    ? (_openBlock(), _createBlock(_component_SectionUploadPhotoForWeightAdjusment, {
                        key: 0,
                        class: "mt-5",
                        title: _ctx.$t('cargo.messages.uploadProofPhotoChangeWeight'),
                        marginBottom: false,
                        defaultOpened: true,
                        showViewAdjustment: _ctx.openAdjustmentWeight,
                        "onUpdate:showViewAdjustment": _cache[9] || (_cache[9] = ($event: any) => (_ctx.openAdjustmentWeight = $event)),
                        modelValue: _ctx.form.photoProof,
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.form.photoProof = $event)),
                        showDefault: _ctx.isRebooking || !!_ctx.form.photoProof.length,
                        isValidationAdjustWeightProofPhotoEnable: 
            _ctx.isValidationAdjustWeightProofPhotoEnable
          ,
                        onOnUploadImage: _ctx.onUploadAdjustmentWeight,
                        onOnDeleteImage: _ctx.onRemoveAdjustmentWeight,
                        onShowViewAdjustment: _cache[11] || (_cache[11] = ($event: any) => (_ctx.openAdjustmentWeight = !_ctx.openAdjustmentWeight))
                      }, null, 8, ["title", "showViewAdjustment", "modelValue", "showDefault", "isValidationAdjustWeightProofPhotoEnable", "onOnUploadImage", "onOnDeleteImage"]))
                    : _createCommentVNode("", true),
                  _hoisted_13
                ]))
              : (_openBlock(), _createBlock("div", _hoisted_14, [
                  _createVNode("div", _hoisted_15, [
                    _createVNode(_component_DataWrapper, {
                      label: _ctx.$t('cargo.labels.noStt'),
                      class: "col-span-1",
                      asterisk: ""
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_LpInput, {
                          ref: "inputStt",
                          error: _ctx.errorSttNumber !== '' || _ctx.isUnpaid || _ctx.isDiffDestination,
                          onChange: _ctx.onCloseNotification,
                          isErrorIconInput: false,
                          isErrorIconCaption: "",
                          errorCaption: _ctx.$t(_ctx.errorSttNumber),
                          onEnter: _ctx.addScanSttNumber,
                          sizeInput: "24px",
                          labelStacked: _ctx.$t('cargo.placeholderAdd'),
                          modelValue: _ctx.scanNumber,
                          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.scanNumber = $event)),
                          placeholder: _ctx.$t('cargo.secondPlaceholderAdd'),
                          bold: !!_ctx.scanNumber
                        }, null, 8, ["error", "onChange", "errorCaption", "onEnter", "labelStacked", "modelValue", "placeholder", "bold"])
                      ]),
                      _: 1
                    }, 8, ["label"]),
                    _createVNode("div", _hoisted_16, [
                      _createVNode(_component_LpButton, {
                        onClick: _cache[13] || (_cache[13] = () => _ctx.addSttNumber()),
                        customClass: "px-12 py-2.5",
                        title: _ctx.$t('cargo.actions.add'),
                        textColor: "white",
                        disabled: _ctx.isDisableAddSttNumber
                      }, null, 8, ["title", "disabled"])
                    ]),
                    _createVNode(_component_ScanFailedCard, { data: _ctx.scanFailedList }, null, 8, ["data"])
                  ]),
                  _hoisted_17,
                  (_ctx.isRTC)
                    ? (_openBlock(), _createBlock("div", _hoisted_18, [
                        _createVNode(_component_DataWrapper, {
                          class: "hidden",
                          label: _ctx.$t('cargo.labels.date')
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_DatePickers, {
                              placeholder: _ctx.$t('cargo.labels.date'),
                              modelValue: _ctx.form.estDepartureDate,
                              minDate: new Date(),
                              onSelected: _ctx.setPeriodeStart,
                              class: "my-2"
                            }, null, 8, ["placeholder", "modelValue", "minDate", "onSelected"])
                          ]),
                          _: 1
                        }, 8, ["label"]),
                        _createVNode(_component_DataWrapper, {
                          class: "hidden",
                          label: _ctx.$t('cargo.labels.destinationCity')
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_SelectSearch, {
                              class: "mt-1.5",
                              onFocus: _cache[14] || (_cache[14] = (e) => _ctx.fetchDestinationCity(e)),
                              onFilter: _cache[15] || (_cache[15] = (e) => _ctx.fetchDestinationCity(e)),
                              isLoading: _ctx.isLoadingCity,
                              options: _ctx.optionDestinationCity,
                              keyName: "label",
                              keyValue: "code",
                              placeholder: _ctx.$t('cargo.placeholders.selectDestinationCity'),
                              modelValue: _ctx.destinationCity,
                              "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (_ctx.destinationCity = $event)),
                              onChange: _ctx.changeDestinationCity
                            }, null, 8, ["isLoading", "options", "placeholder", "modelValue", "onChange"])
                          ]),
                          _: 1
                        }, 8, ["label"]),
                        (_ctx.isCargoTrain || _ctx.isCargoShip)
                          ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                              _createVNode(_component_DataWrapper, {
                                label: _ctx.$t('cargo.labels.cargoCommodityGroup'),
                                asterisk: ""
                              }, {
                                default: _withId(() => [
                                  _createVNode(_component_CustomDropdown, {
                                    class: "my-1.5 w-full",
                                    placeholder: _ctx.$t('cargo.placeholders.selectCommodity'),
                                    options: _ctx.commodityOptions,
                                    onSelect: _ctx.onSelectCommodity,
                                    selectedItem: _ctx.commodityItem,
                                    isCustomWidth: ""
                                  }, null, 8, ["placeholder", "options", "onSelect", "selectedItem"])
                                ]),
                                _: 1
                              }, 8, ["label"]),
                              _createVNode(_component_DataWrapper, {
                                label: _ctx.$t('cargo.labels.cargoProductLowercase'),
                                asterisk: ""
                              }, {
                                default: _withId(() => [
                                  _createVNode(_component_Select, {
                                    onOpenSelect: _ctx.onOpenSelectCargoProduct,
                                    onCloseSelect: _ctx.onCloseSelectCargoProduct,
                                    isOpenMenu: _ctx.isOpenSelectCargoProduct,
                                    value: _ctx.form.cargoProduct,
                                    onChooseSelect: _ctx.onSelectCargoProduct,
                                    dataSelect: _ctx.listProductCargo,
                                    customClass: "w-full",
                                    class: "w-full whitespace-no-wrap my-2 z-10"
                                  }, null, 8, ["onOpenSelect", "onCloseSelect", "isOpenMenu", "value", "onChooseSelect", "dataSelect"])
                                ]),
                                _: 1
                              }, 8, ["label"]),
                              _createVNode(_component_DataWrapper, {
                                label: _ctx.$t('cargo.labels.cargoNumber'),
                                asterisk: ""
                              }, {
                                default: _withId(() => [
                                  _createVNode(_component_LpInput, {
                                    onChange: _ctx.onChangeCargoNumber,
                                    modelValue: _ctx.form.cargoNumber,
                                    "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (_ctx.form.cargoNumber = $event)),
                                    placeholder: _ctx.$t('cargo.placeholders.enterCargo')
                                  }, null, 8, ["onChange", "modelValue", "placeholder"])
                                ]),
                                _: 1
                              }, 8, ["label"]),
                              _createVNode(_component_DataWrapper, {
                                label: _ctx.$t('cargo.labels.vehicleSerialNumber'),
                                asterisk: ""
                              }, {
                                default: _withId(() => [
                                  _createVNode(_component_LpInput, {
                                    onChange: _ctx.onChangeVehicleNumber,
                                    modelValue: _ctx.form.vehicleNumber,
                                    "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => (_ctx.form.vehicleNumber = $event)),
                                    placeholder: _ctx.$t('cargo.placeholders.enterVehicleSerialNumber')
                                  }, null, 8, ["onChange", "modelValue", "placeholder"])
                                ]),
                                _: 1
                              }, 8, ["label"])
                            ], 64))
                          : _createCommentVNode("", true),
                        (_ctx.isCargoTruck)
                          ? (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                              (_ctx.isCargoTruck)
                                ? (_openBlock(), _createBlock(_component_DataWrapper, {
                                    key: 0,
                                    label: _ctx.$t('cargo.labels.cargoCommodityGroup'),
                                    asterisk: ""
                                  }, {
                                    default: _withId(() => [
                                      _createVNode(_component_CustomDropdown, {
                                        class: "my-1.5 w-full",
                                        placeholder: _ctx.$t('cargo.placeholders.selectCommodity'),
                                        options: _ctx.commodityOptions,
                                        onSelect: _ctx.onSelectCommodity,
                                        selectedItem: _ctx.commodityItem,
                                        isCustomWidth: ""
                                      }, null, 8, ["placeholder", "options", "onSelect", "selectedItem"])
                                    ]),
                                    _: 1
                                  }, 8, ["label"]))
                                : _createCommentVNode("", true),
                              _createVNode(_component_DataWrapper, {
                                label: _ctx.$t('cargo.labels.cargoProductLowercase'),
                                asterisk: ""
                              }, {
                                default: _withId(() => [
                                  _createVNode(_component_Select, {
                                    onOpenSelect: _ctx.onOpenSelectCargoProduct,
                                    onCloseSelect: _ctx.onCloseSelectCargoProduct,
                                    isOpenMenu: _ctx.isOpenSelectCargoProduct,
                                    value: _ctx.form.cargoProduct,
                                    onChooseSelect: _ctx.onSelectCargoProduct,
                                    dataSelect: _ctx.listProductCargo,
                                    customClass: "w-full",
                                    class: "w-full whitespace-no-wrap my-2 z-10"
                                  }, null, 8, ["onOpenSelect", "onCloseSelect", "isOpenMenu", "value", "onChooseSelect", "dataSelect"])
                                ]),
                                _: 1
                              }, 8, ["label"]),
                              _createVNode(_component_DataWrapper, {
                                label: _ctx.$t('cargo.labels.vehicleSerialNumber'),
                                asterisk: ""
                              }, {
                                default: _withId(() => [
                                  _createVNode(_component_LpInput, {
                                    onChange: _ctx.onChangeVehicleNumber,
                                    modelValue: _ctx.form.vehicleNumber,
                                    "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => (_ctx.form.vehicleNumber = $event)),
                                    placeholder: _ctx.$t('cargo.placeholders.enterVehicleSerialNumber')
                                  }, null, 8, ["onChange", "modelValue", "placeholder"])
                                ]),
                                _: 1
                              }, 8, ["label"])
                            ], 64))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  (
            !_ctx.isRTC && !_ctx.selectedCargoTypeV2BookingManual && _ctx.sttResultFinal.length
          )
                    ? (_openBlock(), _createBlock(_component_DataWrapper, {
                        key: 1,
                        label: _ctx.$t('cargo.labels.cargoCommodityGroup'),
                        asterisk: "",
                        class: "w-1/5 mt-6"
                      }, {
                        default: _withId(() => [
                          _createVNode(_component_CustomDropdown, {
                            class: "my-1.5 w-full",
                            placeholder: _ctx.$t('cargo.placeholders.selectCommodity'),
                            options: _ctx.commodityOptions,
                            onSelect: _ctx.onSelectCommodity,
                            selectedItem: _ctx.commodityItem,
                            isCustomWidth: ""
                          }, null, 8, ["placeholder", "options", "onSelect", "selectedItem"])
                        ]),
                        _: 1
                      }, 8, ["label"]))
                    : _createCommentVNode("", true),
                  (
            !_ctx.isRTC && !_ctx.selectedCargoTypeV2BookingManual && _ctx.sttResultFinal.length
          )
                    ? (_openBlock(), _createBlock("hr", _hoisted_19))
                    : _createCommentVNode("", true),
                  (_ctx.isCargoPlaneManual || _ctx.isCargoPlaneAuto)
                    ? (_openBlock(), _createBlock("div", {
                        key: 3,
                        class: ["flex flex-row space-x-4", _ctx.selectedCargoTypeV2BookingManual ? 'mt-6' : '']
                      }, [
                        (_ctx.showCommodityGroupPlane)
                          ? (_openBlock(), _createBlock(_component_DataWrapper, {
                              key: 0,
                              label: _ctx.$t('cargo.labels.cargoCommodityGroup'),
                              asterisk: "",
                              class: "w-1/5"
                            }, {
                              default: _withId(() => [
                                _createVNode(_component_CustomDropdown, {
                                  class: "my-1.5 w-full",
                                  placeholder: _ctx.$t('cargo.placeholders.selectCommodity'),
                                  options: _ctx.commodityOptions,
                                  onSelect: _ctx.onSelectCommodity,
                                  selectedItem: _ctx.commodityItem,
                                  isCustomWidth: ""
                                }, null, 8, ["placeholder", "options", "onSelect", "selectedItem"])
                              ]),
                              _: 1
                            }, 8, ["label"]))
                          : _createCommentVNode("", true),
                        (_ctx.isRTC || _ctx.selectedCargoTypeV2BookingManual)
                          ? (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                              _createVNode(_component_DataWrapper, {
                                label: "NOG",
                                optional: "",
                                class: "w-1/4"
                              }, {
                                default: _withId(() => [
                                  _createVNode(_component_LpInput, {
                                    onChange: _ctx.onChangeNog,
                                    modelValue: _ctx.form.nog,
                                    "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => (_ctx.form.nog = $event)),
                                    placeholder: _ctx.$t('cargo.placeholders.enterNog')
                                  }, null, 8, ["onChange", "modelValue", "placeholder"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_DataWrapper, {
                                label: "SHC",
                                optional: "",
                                class: "w-1/4"
                              }, {
                                default: _withId(() => [
                                  _createVNode(_component_LpInput, {
                                    disabled: "",
                                    disableBackground: "",
                                    modelValue: _ctx.shcValue,
                                    "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => (_ctx.shcValue = $event)),
                                    placeholder: _ctx.$t('cargo.placeholders.enterShc')
                                  }, null, 8, ["modelValue", "placeholder"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_DataWrapper, {
                                label: _ctx.$t('cargo.labels.cargoProductLowercase'),
                                class: "w-1/4",
                                asterisk: ""
                              }, {
                                default: _withId(() => [
                                  _createVNode(_component_Select, {
                                    onOpenSelect: _ctx.onOpenSelectCargoProduct,
                                    onCloseSelect: _ctx.onCloseSelectCargoProduct,
                                    isOpenMenu: _ctx.isOpenSelectCargoProduct,
                                    value: _ctx.form.cargoProduct,
                                    onChooseSelect: _ctx.onSelectCargoProduct,
                                    dataSelect: _ctx.listProductCargo,
                                    customClass: "w-full",
                                    class: "w-full whitespace-no-wrap my-2 z-10"
                                  }, null, 8, ["onOpenSelect", "onCloseSelect", "isOpenMenu", "value", "onChooseSelect", "dataSelect"])
                                ]),
                                _: 1
                              }, 8, ["label"])
                            ], 64))
                          : _createCommentVNode("", true)
                      ], 2))
                    : _createCommentVNode("", true),
                  (_ctx.sttResultFinal.length)
                    ? (_openBlock(), _createBlock("div", _hoisted_20, [
                        _createVNode("div", {
                          class: `${_ctx.form.cargoType ? 'py-8' : ''} pb-8`
                        }, [
                          _hoisted_21
                        ], 2),
                        _withDirectives(_createVNode("div", _hoisted_22, [
                          _hoisted_23,
                          _createVNode("p", _hoisted_24, _toDisplayString(_ctx.$t("cargo.messages.volumeDividerInfo")), 1),
                          _createVNode("img", {
                            onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.showInfoDividerCargo = !_ctx.showInfoDividerCargo)),
                            src: _imports_1,
                            class: "w-3 cursor-pointer",
                            alt: "close-white"
                          })
                        ], 512), [
                          [_vShow, _ctx.showInfoDividerCargo]
                        ]),
                        (_ctx.showDimensionPerKoliV1)
                          ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                              _createVNode(_component_WeightSummaryStt),
                              _hoisted_25,
                              _createVNode(_component_WeightSummaryTimbangUlang, {
                                modelValue: _ctx.form,
                                "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => (_ctx.form = $event)),
                                isDimensionChanged: _ctx.isDimensionChanged,
                                "onUpdate:isDimensionChanged": _cache[24] || (_cache[24] = ($event: any) => (_ctx.isDimensionChanged = $event)),
                                actualChargeableWeight: _ctx.actualChargeableWeight,
                                isValidationAdjustWeightProofPhotoEnable: 
                _ctx.isValidationAdjustWeightProofPhotoEnable
              
                              }, null, 8, ["modelValue", "isDimensionChanged", "actualChargeableWeight", "isValidationAdjustWeightProofPhotoEnable"]),
                              (_ctx.isErrorWeightAdjustment)
                                ? (_openBlock(), _createBlock(_component_SectionUploadPhotoForWeightAdjusment, {
                                    key: 0,
                                    class: "mt-5",
                                    title: _ctx.$t('cargo.messages.uploadProofPhotoChangeWeight'),
                                    marginBottom: false,
                                    defaultOpened: true,
                                    showViewAdjustment: _ctx.openAdjustmentWeight,
                                    "onUpdate:showViewAdjustment": _cache[25] || (_cache[25] = ($event: any) => (_ctx.openAdjustmentWeight = $event)),
                                    modelValue: _ctx.form.photoProof,
                                    "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => (_ctx.form.photoProof = $event)),
                                    showDefault: _ctx.isRebooking || !!_ctx.form.photoProof,
                                    isValidationAdjustWeightProofPhotoEnable: 
                _ctx.isValidationAdjustWeightProofPhotoEnable
              ,
                                    onOnUploadImage: _ctx.onUploadAdjustmentWeight,
                                    onOnDeleteImage: _ctx.onRemoveAdjustmentWeight,
                                    onShowViewAdjustment: _cache[27] || (_cache[27] = ($event: any) => (_ctx.openAdjustmentWeight = !_ctx.openAdjustmentWeight))
                                  }, null, 8, ["title", "showViewAdjustment", "modelValue", "showDefault", "isValidationAdjustWeightProofPhotoEnable", "onOnUploadImage", "onOnDeleteImage"]))
                                : _createCommentVNode("", true)
                            ], 64))
                          : (_ctx.showEditDimensionPerKoli)
                            ? (_openBlock(), _createBlock(_component_DimensionPerKoli, { key: 1 }))
                            : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true)
                ]))
          ], 64))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_Notification, {
      titleMessageError: _ctx.$t('cargo.messages.invalidSttBaggingCargo'),
      data: _ctx.detailSttNotification,
      modelValue: _ctx.notification,
      "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => (_ctx.notification = $event)),
      status: _ctx.isErrorNotification ? 'error' : 'success',
      onClose: _ctx.onCloseNotification,
      messageError: _ctx.$t(_ctx.messageErrorNotification)
    }, null, 8, ["titleMessageError", "data", "modelValue", "status", "onClose", "messageError"]),
    _createVNode(_component_NotificationCommodityGrouping, {
      data: _ctx.detailNotificationCommodityGrouping,
      modelValue: _ctx.notificationCommodityGrouping,
      "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => (_ctx.notificationCommodityGrouping = $event)),
      onClose: _ctx.onCloseNotification,
      message: _ctx.detailNotificationCommodityGrouping?.message,
      customIcon: "warning-triangle",
      iconColor: "text-yellow-lp-500",
      title: _ctx.$t('cargo.labels.cargoCommodity')
    }, null, 8, ["data", "modelValue", "onClose", "message", "title"]),
    (_ctx.showNotificationWeight)
      ? (_openBlock(), _createBlock(_Transition, {
          key: 1,
          name: "notification"
        }, {
          default: _withId(() => [
            _createVNode("div", _hoisted_26, [
              _createVNode("p", _hoisted_27, _toDisplayString(_ctx.$t("cargo.messages.minimumWeightRecommendation")), 1),
              _createVNode(_component_Icons, {
                onClick: _cache[30] || (_cache[30] = ($event: any) => (_ctx.setShowNotificationWeight(false))),
                width: "12",
                height: "12",
                name: "icon-x",
                class: "cursor-pointer ml-6",
                color: "#A7A8AA"
              })
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ], 64))
})